document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".card-showcase-section");

  sections.forEach((section) => {
    const slider = section.querySelector(".card-showcase-slider");
    if (!slider) return;

    const cards = slider.querySelectorAll(".flip-card");

    const isMobileOrIpadMini = () => window.innerWidth <= 991;

    const swiper = new Swiper(slider, {
      init: false,
      speed: 700,
      loop: false,
      watchSlidesProgress: true,

      slidesPerView: 1.3,
      centeredSlides: true,
      spaceBetween: 16,

      breakpoints: {
        0: {
          slidesPerView: 1.3,
          centeredSlides: true,
          spaceBetween: 16
        },

        768: {
          slidesPerView: 1.3,
          centeredSlides: true,
          spaceBetween: 20
        },

        992: {
          slidesPerView: 3,
          centeredSlides: false,
          spaceBetween: 24
        },

        1026: {
          slidesPerView: "auto",
          centeredSlides: false,
          spaceBetween: 24
        }
      }
    });

    function resetCards() {
      cards.forEach((card) => {
        card.classList.remove("flipped");
      });
    }

    function flipActiveCard() {
      if (!isMobileOrIpadMini()) return;

      resetCards();

      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const activeCard = activeSlide.querySelector(".flip-card");

      if (activeCard) {
        activeCard.classList.add("flipped");
      }
    }

    swiper.on("init", () => {
      if (isMobileOrIpadMini()) {
        flipActiveCard();
      }
    });

    swiper.on("slideChangeTransitionEnd", () => {
      if (isMobileOrIpadMini()) {
        flipActiveCard();
      }
    });

    swiper.init();

    /* ==========================================
       DESKTOP / IPAD PRO
       FLIP ONLY ONCE
    ========================================== */

    let hasFlippedOnce = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (isMobileOrIpadMini()) return;

          if (entry.isIntersecting && !hasFlippedOnce) {
            hasFlippedOnce = true;

            cards.forEach((card, index) => {
              setTimeout(() => {
                card.classList.add("flipped");
              }, index * 300);
            });

            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.35
      }
    );

    observer.observe(section);

    /* ==========================================
       RESIZE
    ========================================== */

    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        swiper.update();

        if (isMobileOrIpadMini()) {
          flipActiveCard();
        }
      }, 200);
    });
  });
});